import React, { useState } from 'react';
import Spinner from '../Components/Spiner/Spinner'; // Ajusta la ruta según tu estructura
import Topbar from '../Components/Topbar/TopBar'; // Ajusta la ruta según tu estructura
import Navbar from '../Components/Navbar/Navbar';
import Footer from '../Components/Footer/Footer';
import About from '../Components/About/About';
import Team from '../Components/Team/Team';

const Aboutp = () => {
  const [isLoading, setIsLoading] = useState(true);

  React.useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div>
      <Topbar />
      <Navbar /> 
      <Spinner isLoading={isLoading} />
      {!isLoading && (
        <>
          <About />
          <Team />
          <Footer />
        </>
      )}
    </div>
  );
};

export default Aboutp;
